export default {
  'Teklif Formu': 'Offerteformulier',
  'Kayıtlı Teklifler': 'Opgeslagen Offertes',
  'Kullanıcı Adı': 'Gebruikersnaam',
  'Şifre': 'Wachtwoord',
  'Giriş Yap': 'Inloggen',
  'Çıkış Yap': 'Uitloggen',
  'KDV Oranı': 'BTW-tarief',
  'Teklif Durumu': 'Offertestatus',
  'Kaydet': 'Opslaan',
  'PDF Önizleme': 'PDF Voorvertoning',
  'PDF\'ye Aktar': 'Exporteren naar PDF',
  'E-posta ile Gönder': 'Versturen via Email',
  'Alıcı': 'Ontvanger',
  'Tarih': 'Datum',
  'Genel Toplam': 'Totaalbedrag',
  'Not': 'Notitie',
  'KDV': 'BTW',
  'Alt Toplam': 'Subtotaal',
  'Açıklama': 'Beschrijving',
  'Ürün Adı': 'Productnaam',
  'SUT Kodu': 'SUT-code',
  'Birim Alış Fiyatı': 'Eenheidsprijs',
  'Sipariş Adedi': 'Bestellingsaantal',
  'Promosyon Ürün': 'Promotieproduct',
  'Toplam Adet': 'Totaal Aantal',
  'Sipariş Tutarı': 'Bestellingsbedrag',
  'Durum': 'Status',
  'Kabul Edildi': 'Geaccepteerd',
  'Reddedildi': 'Afgewezen',
  'Gönderildi': 'Verzonden',
  'Taslak': 'Concept',
  'Yurtiçi': 'Binnenlands',
  'Yurtdışı': 'Internationaal',
  'Sipariş Oluştur': 'Bestelling Aanmaken',
  'Ürün Sıralaması': 'Product Sortering',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Producten zijn gesorteerd op populariteit en belangrijkheidsniveau',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Cardiologie- en vaatchirurgieproducten worden als prioriteit getoond',
  'Ürün adı, açıklama veya barkod ile ara...': 'Zoeken op productnaam, beschrijving of barcode...',
  'Tüm Kategoriler': 'Alle Categorieën',
  'Kutu görünüm': 'Rasterweergave',
  'Liste görünüm': 'Lijstweergave',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Geen producten gevonden die aan uw criteria voldoen',
  'Ürün Adı Yok': 'Geen Productnaam',
  'Kategori Yok': 'Geen Categorie',
  'Açıklama yok': 'Geen beschrijving',
  'Firma Bilgilerini Doldurun': 'Bedrijfsinformatie Invullen',
  'Sepete Ekle': 'Toevoegen aan Winkelwagen',
  'Firma Bilgileri': 'Bedrijfsinformatie',
  'Ülke Seçimi': 'Landkeuze',
  'Türkiye': 'Turkije',
  'Almanya': 'Duitsland',
  'ABD': 'VS',
  'Firma Ünvanı': 'Bedrijfsnaam',
  'Vergi Dairesi': 'Belastingdienst',
  'Vergi Numarası': 'BTW-nummer',
  'Adres': 'Adres',
  'Şehir': 'Stad',
  'Yetkili': 'Bevoegde Persoon',
  'Telefon': 'Telefoon',
  'Email': 'Email',
  'Bilgileri İlet': 'Informatie Versturen',
  'Lütfen eksik alanları doldurun': 'Vul de lege velden in',
  'Firma kaydedilemedi': 'Bedrijf kon niet worden opgeslagen',
  'Firma bilgileri başarıyla iletildi': 'Bedrijfsinformatie succesvol verzonden',
  'Firma Ünvanı:': 'Bedrijfsnaam:',
  'Yetkili Kişi:': 'Bevoegde Persoon:',
  'Sepetiniz': 'Uw Winkelwagen',
  'Sepetiniz boş': 'Uw winkelwagen is leeg',
  'adet': 'st',
  'Düzenle': 'Bewerken',
  'Kaldır': 'Verwijderen',
  'Siparişi Tamamla': 'Bestelling Voltooien',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Stuur eerst volledige bedrijfsinformatie',
  'Sipariş başarıyla kaydedildi': 'Bestelling succesvol opgeslagen',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Welkomstbericht en toegangslink verzonden naar uw email',
  'Link 3 gün geçerlidir': 'Link is 3 dagen geldig',
  'Sipariş kaydedilemedi': 'Bestelling kon niet worden opgeslagen',
  'Firma Bilgileri Gerekli': 'Bedrijfsinformatie Vereist',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Vul eerst bedrijfsinformatie in om toe te voegen aan winkelwagen',
  'Önce Bilgileri Doldurun': 'Vul Eerst Informatie In',
  'Uyarı': 'Waarschuwing',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'U moet eerst bedrijfsinformatie invullen om toe te voegen aan winkelwagen',
  'SUT Kütüphanesi Tanımı': 'SUT-bibliotheek Definitie',
  'SUT Kodu:': 'SUT-code:',
  'Standart': 'Standaard',
  'Açıklama (isteğe bağlı)': 'Beschrijving (optioneel)',
  'Partner Ol': 'Partner Worden',
  'Partner başvuru popup açılacak': 'Partneraanvraag popup wordt geopend',
  'Dil': 'Taal',
  'E-posta': 'Email',
  'globalPartnersTitle': 'Samenwerking met 30.000 Partners Wereldwijd',
  'globalPartnersDesc': 'Ons uitgebreide wereldwijde netwerk van 30.000 partners bevordert gezamenlijke innovatie, kennisuitwisseling en wederzijds succes. Samen breiden we continu de grenzen van patiëntenzorg uit.',
  'bayiBasvuru': 'INVAMED Partneraanvraagformulier',
  'bayiBasvuruDesc': 'Vul het onderstaande formulier in om lid te worden van het INVAMED-partnernetwerk. Na beoordeling van uw aanvraag nemen we contact met u op.',
  'applyFields': {
    'firma': 'Bedrijfsnaam',
    'vergiNo': 'Belastingdienst / BTW-nummer',
    'yetkili': 'Volledige Naam Bevoegde Persoon',
    'telefon': 'Telefoon',
    'email': 'Email',
    'adres': 'Adres',
    'sektor': 'Activiteitsgebied / Sector',
    'sicil': 'Handelsregisternummer',
    'web': 'Website'
  },
  'Şifremi Unuttum': 'Wachtwoord Vergeten',
  'Demo Giriş': 'Demo Inloggen',
  'Bayi Başvurusu': 'Partneraanvraag',
  'Yardım': 'Hulp',
  'Giriş yapılıyor...': 'Inloggen...',
  'E-posta veya şifre hatalı': 'Onjuiste email of wachtwoord',
  'Şifre sıfırlama e-postası gönderildi': 'Wachtwoordreset-email verzonden',
  'E-posta gönderilemedi': 'Email kon niet worden verzonden',
  'Vergi Dairesi / Vergi No': 'Belastingdienst / BTW-nummer',
  'Yetkili Adı Soyadı': 'Volledige Naam Bevoegde Persoon',
  'Faaliyet Alanı / Sektör': 'Activiteitsgebied / Sector',
  'Ticaret Sicil No': 'Handelsregisternummer',
  'Web Sitesi': 'Website',
  'Temel Bilgiler': 'Basisinformatie',
  'Ek Bilgiler': 'Aanvullende Informatie',
  'Başvuru Gönder': 'Aanvraag Versturen',
  'Başvuru gönderiliyor...': 'Aanvraag verzenden...',
  'Başvuru başarıyla gönderildi': 'Aanvraag succesvol verzonden',
  'Başvuru gönderilemedi': 'Aanvraag kon niet worden verzonden',
  'Sözleşme şartlarını kabul ediyorum': 'Ik accepteer de contractvoorwaarden',
  'Dosya Yükle': 'Bestand Uploaden',
  'Dosya seçilmedi': 'Geen bestand geselecteerd',
  'Dosya yüklendi': 'Bestand succesvol geüpload',
  'Dosya yüklenemedi': 'Bestand kon niet worden geüpload',
  'Tamamla': 'Voltooien',
  'Geri': 'Terug',
  'İleri': 'Volgende',
  'Kapat': 'Sluiten',
  'Yardım İçeriği': 'Hulpinhoud',
  'dil': 'Taal',
  'Üye Ol': 'Registreren',
  'Üye Değil Misiniz?': 'Niet Geregistreerd?',
  'Şimdi Üye Ol': 'Nu Registreren',
  'Misafir Kullanıcı': 'Gastgebruiker',
  'Hızlı Sipariş': 'Snelle Bestelling',
  'Misafir Olarak Sipariş Verin': 'Plaats Bestelling als Gast',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Selecteer snel uw producten en maak uw bestelling zonder in te loggen',
  'Giriş yapmadan sipariş oluşturun': 'Maak bestelling zonder in te loggen',
  'Anında Erişim': 'Directe Toegang',
  'Tüm ürünlere anında erişim': 'Directe toegang tot alle producten',
  'Güvenli İşlem': 'Veilige Transactie',
  'SSL korumalı güvenli sipariş': 'Veilige bestelling met SSL-bescherming',
  'Misafir Olarak Sipariş Oluştur': 'Bestelling Aanmaken als Gast',
  'İpucu:': 'Tip:',
  'Daha fazla özellik için üye olun': 'Registreer voor meer functies',
  'Ücretsiz': 'Gratis',
  'Hızlı': 'Snel',
  'Güvenli': 'Veilig',
  'bayilikSozlesme': 'Ik heb de voorwaarden en partnerovereenkomst gelezen en geaccepteerd.',
  'geri': 'Terug',
  'basvuruGonder': 'Aanvraag Versturen',
  'ileri': 'Volgende',
  'sozlesmeGonderildi': 'Overeenkomst Verzonden naar Uw Email!',
  'sozlesmeDesc': 'Upload de INVAMED Partnerovereenkomst en vereiste documenten die naar uw email zijn verzonden.',
  'tamamla': 'Aanvraag Voltooien',
  'basvuruAlindi': 'Uw Aanvraag Ontvangen!',
  'basvuruAlindiDesc': 'Het INVAMED-team zal uw aanvraag beoordelen en zo spoedig mogelijk contact met u opnemen.',
  'Başvuru Durumu': 'Aanvraagstatus',
  'Başvurunuz onay sürecindedir': 'Uw aanvraag wordt beoordeeld',
  'sifreSifirla': 'Wachtwoord Resetten',
  'sifreSifirlaDesc': 'Voer uw geregistreerde email in, wij sturen wachtwoordreset-instructies.',
  'gonder': 'Versturen',
  'talimatGonderildi': 'Instructies Verzonden',
  'sentDesc': 'Wachtwoordreset-instructies verzonden naar <b>{email}</b>. Controleer uw email.',
  'helpTitle': 'Hoe Kan Ik Inloggen?',
  'helpList': [
    'Om in te loggen op het INVAMED partner-panel, voer uw geregistreerde email en wachtwoord in.',
    'Om in te loggen met demo-gebruiker:',
    'Als u uw wachtwoord bent vergeten, kunt u een reset aanvragen via de link "Wachtwoord Vergeten".',
    'Als u problemen heeft met inloggen, zorg ervoor dat u het juiste email en wachtwoord invoert. Als het probleem aanhoudt, neem contact op met ons support-team.'
  ],
  'partnerlikSozlesmeTitle': 'INVAMED Partnerovereenkomst en Voorwaarden',
  'partnerlikSozlesmeText': `1. ALGEMENE BEPALINGEN

Deze overeenkomst wordt gesloten tussen INVAMED (hierna "Bedrijf") en partnerkandidaat (hierna "Partner") voor samenwerking op het gebied van verkoop van medische apparatuur en accessoires.

2. PARTNERSCHAPSVOORWAARDEN

2.1. Partner moet juridische bevoegdheid hebben voor verkoop van medische apparatuur.
2.2. Partner moet een organisatie zijn die actief is in de gezondheidszorgsector.
2.3. Partner moet over de benodigde licenties en certificaten beschikken.
2.4. Partner moet financieel betrouwbaar zijn.

3. VERPLICHTINGEN VAN DE PARTIJEN

Verplichtingen van het Bedrijf:
3.1. Leveren van hoogwaardige producten en diensten
3.2. Verlenen van technische ondersteuning
3.3. Uitvoeren van training en informatie
3.4. Transparantie in prijsbepaling

Verplichtingen van de Partner:
3.1. Opslaan van producten onder geschikte omstandigheden
3.2. Leveren van hoogwaardige klantenservice
3.3. Naleven van juridische regels
3.4. Beschermen van het merk van het Bedrijf

4. PRIJSBEPALING EN BETALING

4.1. Prijzen worden bepaald door het Bedrijf
4.2. Partner is verplicht om vastgestelde prijzen na te leven
4.3. Betalingsvoorwaarden worden apart bepaald
4.4. Commissietarieven kunnen variëren afhankelijk van prestaties

5. VERTROUWELIJKHEID EN VEILIGHEID

5.1. Partijen zijn verplicht om elkaars vertrouwelijke informatie te beschermen
5.2. Klantinformatie moet vertrouwelijk worden gehouden
5.3. Moet voldoen aan databeschermingsstandaarden

6. DUUR EN BEËINDIGING VAN DE OVEREENKOMST

6.1. Deze overeenkomst geldt voor 1 jaar
6.2. Kan worden verlengd met wederzijdse instemming
6.3. Kan worden opgezegd met 30 dagen opzegtermijn
6.4. Kan onmiddellijk worden opgezegd bij ernstige schending

7. GESCHILLENBESLECHING

7.1. Geschillen worden eerst geprobeerd op te lossen door onderhandelingen
7.2. In gevallen die niet kunnen worden opgelost zijn de rechtbanken van de Republiek Turkije bevoegd

8. INWERKINGTREDING

Deze overeenkomst is gelezen, begrepen en geaccepteerd door de partijen. Ik verklaar dat ik alle bepalingen van deze overeenkomst accepteer en mijn verplichtingen zal nakomen.`,
  'partnerlikSozlesmeOnay': 'Ik heb de INVAMED Partnerovereenkomst en Voorwaarden hierboven gelezen, begrepen en geaccepteerd. Ik verklaar dat ik alle bepalingen van deze overeenkomst accepteer en mijn verplichtingen zal nakomen.',
  'sozlesmeyiGoruntule': 'Overeenkomst Bekijken',
  'sozlesmeyiKapat': 'Sluiten',
  'Ürün': 'Product',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Selecteer uit de productlijst om product toe te voegen',
  'Etiketler': 'Labels',
  'Öncelikli': 'Prioriteit',
  'Ülke Seçiniz': 'Selecteer Land',
  'Firma / Sağlık Profesyoneli': 'Bedrijf / Gezondheidsprofessional',
  'Şehir Seçiniz': 'Selecteer Stad',
  'Yetkili Kişi': 'Bevoegde Persoon',
  'UDI Kodu': 'UDI-code',
  'Teklif başarıyla kaydedildi!': 'Offerte succesvol opgeslagen!',
  'Aynı teklif zaten kayıtlı!': 'Dezelfde offerte is al opgeslagen!',
  'Kullanıcı adı veya şifre hatalı!': 'Onjuiste gebruikersnaam of wachtwoord!',
  'Teklif No': 'Offertenummer',
  'Teklifler': 'Offertes',
  'Yedeklenecek teklif yok!': 'Geen offertes om te backuppen!',
  'Yedek dosyası indirildi.': 'Backupbestand gedownload.',
  'Yedek başarıyla yüklendi.': 'Backup succesvol geladen.',
  'Geçersiz veya bozuk dosya!': 'Ongeldig of beschadigd bestand!',
  'Yedekle (JSON)': 'Backup (JSON)',
  'Geri Yükle': 'Herstellen',
  'Kayıtlı teklif yok.': 'Geen opgeslagen offertes.',
  'E-posta Durumu': 'Email Status',
  'İşlemler': 'Transacties',
  'E-posta ile gönderildi': 'Verzonden via email',
  'E-posta gönderilmedi': 'Email niet verzonden',
  'Görüntüle': 'Bekijken',
  'Sil': 'Verwijderen',
  'Gönderildi': 'Verzonden',
  'Gönderilmedi': 'Niet Verzonden',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'Offerte-ID niet gevonden! Probeer opnieuw.',
  'Lütfen partner seçiniz.': 'Selecteer een partner.',
  'Lütfen teslimat tarihi belirtiniz.': 'Geef een leveringsdatum op.',
  'Proforma başarıyla oluşturuldu!': 'Proforma succesvol aangemaakt!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Proforma aangemaakt maar product kon niet worden toegevoegd. Controleer de console voor details.',
  'Link başarıyla silindi': 'Link succesvol verwijderd',
  'Link kopyalandı!': 'Link gekopieerd!',
  'Ödeme durumu başarıyla güncellendi!': 'Betalingsstatus succesvol bijgewerkt!',
  'dosyası okunamadı!': 'bestand kon niet worden gelezen!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'U moet SUT-code en prijs-kolommen selecteren voor alle bestanden!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Geen geldige rijen gevonden om te laden! Zorg ervoor dat er rijen zijn met ingevulde SUT-code en prijs in het bestand.',
  'Yükleme sırasında hata oluştu!': 'Er is een fout opgetreden tijdens het laden!',
  'Otomatik etiket ekleme başarısız!': 'Automatische labeltoevoeging mislukt!',
  'Etiketler başarıyla güncellendi!': 'Labels succesvol bijgewerkt!',
  'Etiketler güncellenirken hata oluştu!': 'Er is een fout opgetreden tijdens het bijwerken van labels!',
  'Resim başarıyla yüklendi!': 'Afbeelding succesvol geüpload!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Afbeelding geüpload maar product kon niet worden bijgewerkt!',
  'Resim yüklenirken hata oluştu!': 'Er is een fout opgetreden tijdens het uploaden van afbeelding!',
  'Ürün başarıyla güncellendi!': 'Product succesvol bijgewerkt!',
  'Ürün güncellenirken hata oluştu!': 'Er is een fout opgetreden tijdens het bijwerken van product!',
  'Hata:': 'Fout:',
  'Güncelleme hatası:': 'Updatefout:',
  'Alanlar yüklendi:': 'Velden geladen:',
  'alan': 'veld',
  'Connect Free!': 'Gratis verbinden!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Ontdek onze meest populaire producten',
  'Tüm Kategoriler': 'Alle categorieën',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 producten weergegeven (Totaal: 8000+)',
  'Tüm Ürünleri Gör →': 'Bekijk alle producten →',
  'Detaylar': 'Details',
  'Sipariş Ver': 'Nu bestellen',
  'Giriş Yap': 'Inloggen',
  'Hesabınıza giriş yapın': 'Log in op uw account',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Deze site wordt beschermd door reCAPTCHA en het Google Privacybeleid en de Servicevoorwaarden zijn van toepassing.',
  'Ürün Kataloğumuz': 'Onze productcatalogus',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'We bieden meer dan 8000 producten aan',
  '1,3B': '1,3K',
  'Partner': 'Partner',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Totale productie',
  '23': '23',
  'Branş': 'Tak',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Totale bestellingen',
  'Connect Now': 'Nu verbinden',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Registreer gratis om toegang te krijgen tot alle informatie op één plek.',
  'Ürün Detayları': 'Productdetails',
  'Kapat': 'Sluiten',
  'Yükleniyor...': 'Laden...',
  'Hata': 'Fout',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} producten weergegeven (Totaal: 8000+)',
  'Şehir Seçimi': 'Stadsselectie',
  'Firma / Sağlık Profesyoneli': 'Bedrijf / Gezondheidsprofessional',
  'Yetkili Kişi': 'Geautoriseerde Persoon',
  'Telefon': 'Telefoon',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Basisinformatie',
  'Ek Bilgiler': 'Aanvullende Informatie',
  'Faaliyet Alanı / Sektör': 'Activiteitsgebied / Sector',
  'Ülke Seçimi': 'Land Selectie',
  'Ülke adı veya kodu ara...': 'Zoek landnaam of code...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'Amerika',
  'region.Asya': 'Azië',
  'region.Afrika': 'Afrika',
  'region.Okyanusya': 'Oceanië',
  'region.Diğer': 'Andere',
  'country.TR': 'Turkije',
  'country.US': 'Verenigde Staten',
  'country.DE': 'Duitsland',
  'country.FR': 'Frankrijk',
  'country.GB': 'Verenigd Koninkrijk',
  'country.IT': 'Italië',
  'country.ES': 'Spanje',
  'country.RU': 'Rusland',
  'country.CN': 'China',
  'country.JP': 'Japan',
  'country.KR': 'Zuid-Korea',
  'country.IN': 'India',
  'country.BR': 'Brazilië',
  'country.CA': 'Canada',
  'country.AU': 'Australië',
  'Ticaret Sicil No': 'Handelsregister Nummer',
};
